import { CommonModule } from '@angular/common';
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { ButtonComponent, ButtonTriggerEvent } from '../button/button.component';
import { AuthService, TokenInfo } from '../../services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { getRouteUrl, routeConfigs } from '../../constants/route.config';
import jwt_decode from 'jwt-decode';
import { catchError, finalize, of } from 'rxjs';

@Component({
  selector: 'ig-login',
  standalone: true,
  imports: [CommonModule, SharedModule, FormsModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent {
  credentials = { userName: '', password: '' };
  form: FormGroup;
  accountStatus: string | null = null;

  @ViewChild('loginBtn', { static: true }) loginBtn: ButtonComponent;

  constructor(
    private _fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.form = this._fb.group({
      userName: [null, [Validators.required]],
      password: [null, [Validators.required]],
    });
  }

  // Update login method
  login(event?: ButtonTriggerEvent) {
    this.accountStatus = null;
    // const returnUrl = this.route.snapshot.queryParams['returnUrl'];

    // trigger when enter key pressed
    !event && this.loginBtn.load();

    this.authService
      .login(this.credentials)
      .pipe(
        catchError((error) => {
          console.error('Login failed:', error);
          this.accountStatus = 'Invalid credentials';
          return of(null);
        }),
        finalize(() => {
          event?.complete();
          !event && this.loginBtn.complete();
        })
      )
      .subscribe({
        next: (token) => {
          console.log('Login successful:', token);

          if (!token) {
            return;
          }

          // Update the usage in login method
          let tokenInfo = jwt_decode<TokenInfo>(token);
          console.log(tokenInfo);

          if (tokenInfo.status !== 'live') {
            this.accountStatus = 'Your account is disabled, please contact administrator.';
            return;
          }

          if (tokenInfo.isAdministrator) {
            if (tokenInfo.role === 'ig-admin') {
              this.router.navigateByUrl(getRouteUrl(routeConfigs.admin.accounts));
            }
            if (tokenInfo.role === 'ig-event-puller') {
              this.router.navigateByUrl(getRouteUrl(routeConfigs.admin));
            }
          } else {
            if (!window.location.href.includes('localhost')) {
              try {
                window['pendo'].initialize({
                  account: {
                    id: tokenInfo.userName,
                    accountName: tokenInfo.userName,
                  },
                });
              } catch (error) {
                console.error(error);
              }
            }

            // for account users (not login with account name, but use user name under an account)
            // need to redirect to tokenInfo.hubName instead of tokenInfo.userName
            this.router.navigateByUrl(
              getRouteUrl(routeConfigs.dashboard.eventCalendar).replace(
                ':hubName',
                tokenInfo.hubName || tokenInfo.userName
              )
            );
          }
        },
        error: (error) => {
          console.error('Login failed:', error);
          event.complete();
          // Handle error display here
        },
      });
  }
}
